import objToUrlParam from "services/utils/objToUrlParam"

export const PORTAL = "portal/v1"
export const COMMUNICATION = "communication/v1"
export const SENSEDIA = "sensedia"
export const SENSEDIA_CORP = "sensedia/corp"
export const PORTAL_AWS = "amazonaws"
export const HTTP_CLIENT = "http-client"
export const BFF = "bff"
export const BFF_PUB = "bff-pub"
export const DEFAULT_CLIENT_NAME = BFF

export const CLIENTS = {
  SENSEDIA: "sensedia",
  SENSEDIA_CORP: "sensedia/corp",
  PORTAL: "portal/v1",
  PORTAL_AWS: "amazonaws",
  HTTP_CLIENT: "http-client",
  BFF: "",
  BFF_PUB: ""
}

const Routes = {}

Routes[PORTAL] = {
  users: (params) => `customers/${params.customerKey}/users`,
  downloadHugeInvoice: (params) =>
    `/customers/${params.customerKey}/bills/${params.accountNumber}/invoices/${params.invoiceKey}/files/swift`
}

Routes[HTTP_CLIENT] = {
  gSheetsAccountDeactivationResearch: () =>
    "https://script.google.com/macros/s/AKfycbwxnFWtASCj9Rfj_csCYRyKCHNmColg3gmCuLnjsljDgw0wxyfB/exec"
}

Routes[BFF_PUB] = {
  zipCode: (params) => `geographic/zipCode/${params.zipCode}`,
  getComplementType: () => `geographic/type-complements`
}

Routes[BFF] = {
  login: () => "auth/login",
  getPermissions: () => "auth/permissions",
  customer: () => "customer",
  getCustomerTickets: ({ customerId }) =>
    `/loyalty/reward-coupons/${customerId}`,
  getSvas: ({ customerId }) => `product/sva/customer/${customerId}`,
  getBillingAccountAlias: () => "/alias",
  setBillingAccountAlias: () => "/alias",
  deleteBillingAccountAlias: () => "/alias",
  productsAll: (params) => {
    if (params.customerKey) {
      delete params.customerKey
    }

    params.application = "PORTAL"
    return `product/all${objToUrlParam(params)}`
  },
  productsAllSubsidiary: ({ documentNumberSubsidiary }) => {
    return `product/all/subsidiary/${documentNumberSubsidiary}`
  },
  productDetail: (params) => {
    if (params.customerKey) {
      delete params.customerKey
    }

    return `product/detail${objToUrlParam(params)}`
  },
  getPixInvoice: () => `invoice/pix/qrcode`,
  getInvoiceBarCode: (params) =>
    `invoice/barcode/${params.billingAccountNumber}`,
  sendInvoiceByEmail: () => `invoice/mail`,
  customerEditData: () => "customer/edit",
  customerContactEditData: () => "customer/contact/edit",
  userValidatePassword: () => "user/validate-password",
  userChangePassword: () => "user/change-password",
  createContact: () => "user/create-contact",
  generateSVAToken: () => "algar-forever/sva-gen-token",
  calculateNumberPlots: () =>
    `/customer/invoice-negotiation/calculate-number-plots`,
  approvePayment: () => "/invoice/negotiation/approve",
  dataTraffic: (params) => `customer/${params.contractId}/traffic-data`,
  invoiceNegotiation: () => "/invoice/negotiation/expired",
  calcNegotiation: () => "/invoice/negotiation/payment-options/request",
  statusCalc: ({ requestId }) =>
    `invoice/negotiation/status-calculation/${requestId}`,
  resultCalc: ({ requestId }) =>
    `invoice/negotiation/result-calculation/${requestId}`,
  installments: () => "/invoice/negotiation/installments",
  sendProductsPlantByEmail: () => "product/products-plant/mail",
  invoices: (params) => `invoice/account/${params.accountNumber}`,
  getDocuments: ({ agreementId }) => `customer/document/${agreementId}`,
  sendDocumentsByEmail: () => "customer/document/send-by-email",
  bills: () => `/billing/account`,
  newGetOpenInvoices: () => `/invoice/open`,
  filter: (params) => `/invoice/open/service/${params.serviceId}`,
  servicesOrder: () => "demands",
  servicesOrderByProtocol: (params) => `demands/${params.protocol}`,
  audioProtocol: (params) => `demands/${params.protocol}/audio`,
  downloadServiceOrder: () => "demands/file",
  sendServiceOrder: () => "demands/mail",
  downloadInvoice: () => "invoice/file",
  downloadFileDetails: () => "invoice/file/details",
  experience: () => `/experience`,
  changeDueDate: () => `billing/due-date`,
  getUsageProfiles: (params) =>
    `customer/phone/${params.productKey}/usage-profile`,
  getUsageProfilesConsolidated: (params) =>
    `customer/phone/${params.productKey}/usage-profile/consolidated`,
  sendUsageProfileFiles: (params) =>
    `customer/phone/${params.productKey}/usage-profile/mail`,
  downloadUsageProfilesFiles: (params) =>
    `customer/phone/${params.productKey}/usage-profile/file`,
  dataTrafficDetails: (params) =>
    `/product/${params.serviceId}/traffic-data-details?startDate=${params.startDate}&endDate=${params.endDate}`,
  sendTrafficMail: (params) =>
    `/product/${params.serviceId}/traffic-data-details/mail`,
  downloadTraffic: (params) =>
    `/product/${params.serviceId}/traffic-data-details/file`,
  invoiceNegotiationLogs: (params) =>
    `invoice/history/payment-method${objToUrlParam(params)}`,
  updateBillSendType: () => `billing/send-type`,
  updateAddress: (params) =>
    `billing/update-billing-address/${params.agreementId}/address`,
  bankData: (params) => `billing/debit-automatic/${params.accountNumber}`,
  banks: () => "billing/financial/banks",
  activeDebitCard: () => "billing/debit-automatic",
  updateEmailNegotiation: () => "/user/recupera",
  unblockInTrust: () => "billing/unblock-in-trust",
  canCancel: () => "product/can-cancel",
  cancellation: () => "product/cancel",
  inactivateUserContact: () => "user/inactivate-user-contact",
  signInSubsidiary: () => "auth/subsidiary",
  getCancellationValue: (params) => `/invoice/cancelation/${params.invoiceId}`,
  getNrcValue: (params) => `/invoice/nrc/${params.invoiceId}`,
  getAdjustment: (params) => `/invoice/adjustment/${params.invoiceId}`,
  getInterestFines: (params) => `/invoice/interest/${params.invoiceId}`,
  getReadjustmentIgp: (params) =>
    `/invoice/readjustment/igp/${params.invoiceId}`,
  getReadjustmentAnatel: (params) =>
    `/invoice/readjustment/anatel/${params.invoiceId}`,
  getInvoiceValue: (params) => `/invoice/value/${params.invoiceId}`,
  getInvoiceDisputingInformation: (params) =>
    `/invoice/service-requests/detail/${params.requestId}`,
  sendInvoiceDisputingFile: (params) =>
    `/invoice/request/post-paid-contestation/upload/${params.customerId}`,
  invoiceDisputing: () => `/invoice/request/post-paid-contestation`,
  findAllAssetDetail: ({ assetId }) => `product/sva/asset/${assetId}`,
  getServiceRequests: (params) =>
    `product/service-request/load-redirect/customer/${params.customerId}/asset/${params.assetId}/page/${params.page}/size/${params.size}`,
  getRemainingHours: (params) =>
    `product/service-request/load-redirect/customer/${params.customerId}/asset/${params.assetId}/remaining-hours`,
  createServiceRequest: () => `/product/service-request/load-redirect/create`,
  getAssetDetails: (params) =>
    `/product/detail?serviceId=${params.serviceId}&crmSystem=${params.crmSystem}&_expand=${params._expand}`,
  getAssetDetailsV2: (params) =>
    `/product/details/v2?serviceId=${params.serviceId}&crmSystem=${params.crmSystem}`,
  febrabanAccounts: (params) =>
    `/invoice/account/${params.accountNumber}/febraban`,
  downloadFebrabanAccount: () => `/billing/invoice-febraban/files`,
  getBlockedProducts: () => `product/products-with-blocked`,
  getProductFixedVoice: () => `billing/product-fixed-voice`,
  portabilityInformationReturn: ({ telephoneNumber }) =>
    `billing/portability-information/${telephoneNumber}`,
  getInvoicesSummary: () => `/v2/billing/invoices/summary`,
  getInvoicesHistoric: () => `/v2/billing/invoices/historic`,
  getLocationsBypostCode: ({ postCode }) =>
    `/geographic/address-by-postCode?postCode=${postCode}&size=1000`,
  validateAddress: () => `/geographic/validate-address`,
  getRangeFixa: ({ localityCode }) =>
    `/checkout/landline-phone?localityCode=${localityCode}`,
  newSalesOrder: () => `/product/sales-order`,
  partnerLocality: () => `sale-portability/partner-locality`,
  partnerSales: () => `sale-portability/partner-sales`,
  partnerOrderService: () => `sale-portability/partner-order-service`,
  partnerOccurrences: () => `sale-portability/partner-occurrences`,
  partnerDashboard: () => `sale-portability/partner-dashboard`,
  partnerDatesReschedule: (params) =>
    `sale-portability/partner-dates-reschedule/${params.protocol}`,
  editClientDashboard: () => `sale-portability/partner-edit-client`,
  partnerRescheduleSuspend: () => `sale-portability/partner-reschedule-suspend`,
  partnerCancel: () => `sale-portability/partner-cancel`,
  getCalls: ({ initialDate, finalDate }) =>
    `/product/calls?initialDate=${initialDate}&finalDate=${finalDate}`,
  inventarioDigital: (params) =>
    `/product/digital-inventory-chatbots/${params.circuit}`,
  inventarioDigitalHostname: (params) =>
    `/product/digital-inventory-hostname/${params.hostname}`,
  tncm2: () => `/product/digital-inventory-devices-ping`,
  tncm3: (params) => `/product/digital-inventory-devices-ping/${params.pingId}`,
  tncm4: (params) =>
    `/product/digital-inventory/ping/${params.pingId}/workitem/${params.workItemId}`,
  protocol: () => `/support/create-protocol`,
  interaction: () => `/support/create-interaction`,
  openTicket: () => `/support/open-ticket`,
  addComments: () => `/support/add-comments`,
  unblockingCircuit: () => `/support/unblocking-circuit`,
  listModem: () => `/support/list-modem`,
  resetModem: () => `/support/reset-modem`,
  sendEmailProtocol: () => `/user/email/messages`,
  closeOrder: () => "/product/close-orders/b2b",
  getLastOrders: ({ assetNum }) => `/product/last-orders/${assetNum}`,
  getVerifyCircuit: ({ circuitId }) => `/product/verify-circuit/${circuitId}`,
  getVerifyMassive: ({ circuitId }) => `/product/verify-massive/${circuitId}`,
  getDetailProtocol: ({ protocol }) => `/product/detail-protocol/${protocol}`,
  getVerifyCalled: () => `/product/verify-called`,
  preScheduleWindows: ({ orderId }) => `/product/pre-schedule/${orderId}`,
  preSchedule: () => `/product/pre-schedule`,
  downloadHugeInvoice: (params) =>
    `/invoice/file/swift${objToUrlParam(params)}`,
  downloadFileInvoice: (params) => `/invoice/download/${objToUrlParam(params)}`,
  rechargeLogin: () => `/recharge/login-pagtel`,
  rechargeHash: () => `/recharge/hash-document`,
  addRechargeCard: () => `/recharge/add-card`,
  getRechargeCard: () => `/recharge/get-card`,
  deleteRechargeCard: () => `/recharge/delete-card`,
  getRechargeValues: () => `/recharge/values-recharge`,
  makeRecharge: () => `/recharge/make`,
  historyRecharge: () => `/recharge/financial-history`,
  financialHistoryByDocument: () => `/recharge/financial-history-by-document`,
  downloadMultipleInvoices: () => `/invoice/download/multiple`,
  authenticate: () => `/auth/oauth2`,
  algarInitialTest: () => `/algar-sat/tests`,
  getAlgarVerifyTest: ({ idTeste }) => `/algar-sat/verify-test/${idTeste}`,
  createLead: ({ circuitId }) => `/leads/${circuitId}`,
  attachmentFileOnOrder: ({ orderId }) => `/support/attachment/${orderId}`,
  multiUser: () => `user/multi-user`,
  disableMultiUser: () => `user/inactive-multi-user`,
  activeMultiUser: () => `user/active-multi-user`,
  validateInstallationAddress: () => `/geographic/validate/instalation-address`,
  calculateChangeTax: () => `/contract/address/calculate-change-tax`,
  saveNewInstallationAddress: () => `/contract/address/change-installation`,
  validateAndQueryAddress: () => "/customer/address/validate-and-query",
  createInteractionChangeInstallationAddress: () =>
    "/support/create-interaction",
  nbo: ({ circuit }) => `/offers/nbo/${circuit}`,
  getContracts: ({ serviceId, agreementId, productId }) =>
    `/contract/attachment?serviceId=${serviceId}&agreementId=${agreementId}&productId=${productId}`,
  getContractsGed: ({ agreementId }) =>
    `/contract/attachment-ged?assetId=${agreementId}`,
  getFileContract: () => `/contract/attachment/file`,
  downloadContract: ({ pathUrl, fileName }) =>
    `/contract/attachment/${pathUrl}/download?fileName=${fileName}`,
  sendMailContracts: () => `/contract/attachment/mail`,
  getSalesOrders: () => "/corporate/sales-order/by-document-number-and-step-id",
  checkAdvanceNoticeInCancellation: ({ assetId }) =>
    `/product/cancellation/advance-notice?assetId=${assetId}`,
  checkCancellationFines: () => "/product/cancellation/fines",
  requestCancellation: () => "/product/cancellation/create",
  sendProductCancellationRequest: ({ sendMode }) =>
    `/product/product-cancellation-request/send/?sendMode=${sendMode}`,
  listConfigValues: () => "/corporate/list-values",
  updateNotificationMethods: () => "/customer/update/notification-methods",
  getNotificationMethods: () => "/customer/notification-methods",
  createTechnicalSupportProtocol: () => "/product/support-cellphone-protocol",
  productIsStandard: ({ assetId }) => `/product/is-standard/${assetId}`,
  acceptSalesOrdersTerm: ({ id }) => `/corporate/sales-order/accept/${id}`,
  checkVerifyMassive: () => "/product/massive-circuit",
  getSupportOrder: ({ circuitId }) => `/support/order?circuitId=${circuitId}`,
  supportListModem: () => "/support/list-modem",
  supportResetModem: () => "/support/reset-modem",
  getSupportTimeSlots: ({ orderId }) =>
    `/support/order/time-slots?orderId=${orderId}`,
  createSupportScheduling: () => "/support/scheduling",
  getProtocolDetails: ({ protocolId }) => `/customer/protocols/${protocolId}`,
  requestAudioProtocol: () => "/customer/audio-protocol",
  getServiceRequestsCustomer: (params) =>
    `/customer/service-requests-customer/${objToUrlParam(params)}`,
  getProductsInInvoice: () => "/billing/products",
  validateBeegolAccessAvailability: () =>
    "/customer/beegol/access-availability",
  getSubsidiaryDetails: ({ documentNumberSubsidiary }) =>
    `/customer/subsidiary/${documentNumberSubsidiary}`,
  listInvoiceRecharges: ({ invoiceNumber }) =>
    `/recharge/invoices/${invoiceNumber.slice(1)}`,
  downloadInvoiceRecharge: ({ id }) => `/recharge/invoices/${id}`,
  downloadMultipleInvoiceRecharges: () =>
    "/recharge/invoices/multiple-download",
  getValidateConglomerates: () => "/customer/validate-conglomerates",
  leadShareEnergy: () => "/product/lead-share-energy",
  getEnergyDistributor: () => "/product/energy-distributor",
  getWorkOrdersSOM: () => "/support/work-order-som",
  getCommentsOrderSOM: ({ orderId, page, size }) =>
    `/support/comments-order-som/?orderId=${orderId}&page=${page}&size=${size}`,
  getWorkOrderControlDesk: () => "/support/work-order-list",
  getCommentsControlDesk: ({ orderId, page, size }) =>
    `/support/work-order-comments/?orderId=${orderId}&page=${page}&size=${size}`,
  createWorkOrderControlDesk: () => "/support/create-work-order",
  getServiceCategory: () => "/support/work-order-service-category",
  getTypeRequest: () => "/support/work-order-type-request",
  getTypeDomains: () => "/support/work-order-type-domains"
}

export default Routes



// WEBPACK FOOTER //
// ./src/services/network/routes.js